module.exports = __webpack_public_path__ + "static/media/Paus soffa 2-sits med recliners pausakomb375hg miljö 2023 4.f7e5ceb3.jpg";